<template>
  <v-row no-gutters class="mt-8">
    <v-col cols="6" offset="3">
      <v-card>
        <v-card-title>Unknown Builder</v-card-title>
        <v-card-text>
          <p>You most likely arrived here due to a misconfiguration or error.</p>
          <p>Contact support!</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="$router.go(-1)">Go Back!</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'unknown-builder',
  data: function () {
    return {}
  }
}
</script>
